import angular from 'angular';
import UIRouter from 'angular-ui-router';

import './addExamPopup.htm';
import './addStudentPopup.htm';
import './addMarksPopup.htm';

import createStub from '../olr-common/createStub';
import './styles/index.scss';
import template from './index.html';
import IndvClassController from './IndvClassController';

    
let namespace = angular.module('olr-mainfe-indv-class', [
  UIRouter,
  'olr-common'
]);

namespace.config(function($stateProvider) {
  $stateProvider.state('olr.mainfe.indvclass', {
    url: '/class/:classRoomName?subName&cId',
    controller: 'IndvClassController as indvClassCtrl',
    template: template
  });
});

namespace.controller('IndvClassController', IndvClassController);

export default namespace.name;





/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-indv-class/index.js
 **/